import { isoToLocalDate } from "@jugl-web/utils";
import {
  ActiveTaskTimeLogDto,
  CreateTaskTimeLogDto,
  MyTimeLogsSummaryDto,
  TaskTimeLogDto,
  TimeLogListItemDto,
  UpdateTaskTimeLogDto,
} from "./TaskTimeLogDto";
import {
  ActiveTaskTimeLogModel,
  CreateTaskTimeLogModel,
  MyTimeLogsSummaryModel,
  TaskTimeLogModel,
  TimeLogListItemModel,
  UpdateTaskTimeLogModel,
} from "./TaskTimeLogModel";

export const transformTaskTimeLogDtoToModel = (
  dto: TaskTimeLogDto
): TaskTimeLogModel => ({
  id: dto.id,
  userId: dto.user_id,
  startDate: isoToLocalDate(dto.cin),
  endDate: dto.cout ? isoToLocalDate(dto.cout) : null,
  notes: dto.notes || "",
  duration: dto.duration,
  updatedAt: isoToLocalDate(dto.updated_at),
  orderId: dto.order_id,
  orderResponseId: dto.order_resp,
  isManualOrder: dto.is_manual_order,
  logMode: dto.log_mode,
});

export const transformActiveTaskTimeLogDtoToModel = (
  dto: ActiveTaskTimeLogDto
): ActiveTaskTimeLogModel => ({
  ...transformTaskTimeLogDtoToModel(dto),
  boardId: dto.board_id,
  taskId: dto.task_id,
  taskName: dto.task_name,
});

export const transformCreateTaskTimeLogModelToDto = (
  model: CreateTaskTimeLogModel
): CreateTaskTimeLogDto => ({
  cin: model.startDate.toISOString(),
  cout: model.endDate ? model.endDate.toISOString() : null,
  notes: model.notes,
  log_mode: model.logMode,
});

export const transformUpdateTaskTimeLogModelToDto = (
  model: UpdateTaskTimeLogModel
): UpdateTaskTimeLogDto => {
  const dto: UpdateTaskTimeLogDto = {};

  if (model.startDate !== undefined) {
    dto.cin = model.startDate.toISOString();
  }

  if (model.endDate !== undefined) {
    dto.cout = model.endDate ? model.endDate.toISOString() : null;
  }

  if (model.notes !== undefined) {
    dto.notes = model.notes;
  }

  if (model.logMode !== undefined) {
    dto.log_mode = model.logMode;
  }

  return dto;
};

export const transformMyTimeLogsSummaryDtoToModel = (
  dto: MyTimeLogsSummaryDto
): MyTimeLogsSummaryModel => ({
  logs: dto.logs.map(transformTaskTimeLogDtoToModel),
  totalDuration: dto.total_duration,
});

export const transformTimeLogListItemDtoToModel = (
  dto: TimeLogListItemDto
): TimeLogListItemModel => transformActiveTaskTimeLogDtoToModel(dto);
